module.exports = __webpack_public_path__ + "static/media/process-automation_SK.0df8cecf.md";